import { createI18n } from 'vue-i18n';
import zh from './locales/zh.js';
import en from './locales/en.js';
import ja from './locales/ja.js';

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'zh', // 默认中文
  fallbackLocale: 'en',
  messages: {
    zh,
    en,
    ja
  }
});

export default i18n;
